import { render, staticRenderFns } from "./inactive-actions.vue?vue&type=template&id=5cb7e86e"
import script from "./inactive-actions.vue?vue&type=script&lang=js"
export * from "./inactive-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports